/**
 * Nomad Lane — mobile menu A/B variants.
 *
 * This is the whole script, and it only exists to close the drawer.
 *
 * Everything else the panel needs is already handled without JS: opening,
 * the focus trap, the body scroll lock and the slide transition all come from
 * HeaderDrawer in global.js via the untouched <details>/<summary> wrapper, and
 * variant B's product strip is CSS scroll-snap.
 *
 * Why closing needs help: the design puts an X inside the panel, but
 * MenuDrawer.bindEvents() binds onCloseButtonClick to every <button> in the
 * drawer, and that path runs closeSubmenu(), which never removes
 * `body.overflow-hidden-{breakpoint}`. Using a <button> would leave the page
 * scroll-locked behind a closed menu. So the control is a role="button" span,
 * invisible to that binding, and it forwards to the real <summary> — which
 * routes through onSummaryClick -> closeMenuDrawer and unlocks properly.
 *
 * ponytail: delegated from document, so it survives section re-renders in the
 * theme editor without needing a re-init hook.
 */
(function () {
  'use strict';

  function closeDrawer(target) {
    var drawer = target.closest('header-drawer');
    if (!drawer) return;

    var summary = drawer.querySelector('summary');
    var details = drawer.querySelector('details');
    if (!summary || !details || !details.hasAttribute('open')) return;

    summary.click();
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-nl-menu-close]');
    if (!control) return;

    event.preventDefault();
    closeDrawer(control);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

    var control = event.target.closest('[data-nl-menu-close]');
    if (!control) return;

    event.preventDefault();
    closeDrawer(control);
  });

  /**
   * Declaw the search form's buttons.
   *
   * The search field is the theme's own <predictive-search>, which needs both a
   * reset and a submit button: PredictiveSearch extends SearchForm, and
   * SearchForm.onChange -> toggleResetButton() dereferences
   * button[type="reset"] on every keystroke. Omitting them throws before the
   * search ever runs.
   *
   * But MenuDrawer.bindEvents() has already bound onCloseButtonClick to those
   * same buttons, so clearing or submitting the search would close the whole
   * menu and leave `body.overflow-hidden-*` behind. The theme's own opt-out is
   * a `:not()` class list, but every class in it carries styling.
   *
   * Replacing each button with a clone drops the theme's listeners (they aren't
   * copied) while keeping the markup identical. SearchForm cached its
   * resetButton in the constructor, so re-point that at the live node — and if
   * the element upgrades after this runs, its constructor finds the clone
   * anyway. Both orderings are safe.
   */
  function declawSearchButtons() {
    document.querySelectorAll('header-drawer predictive-search').forEach(function (search) {
      search.querySelectorAll('button').forEach(function (button) {
        button.replaceWith(button.cloneNode(true));
      });
      search.resetButton = search.querySelector('button[type="reset"]');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', declawSearchButtons);
  } else {
    declawSearchButtons();
  }
})();
